(function (w, $, _) {

    const assetIds = ['checkout2', '~/Controls/Site/CheckOut2.min.js'];
    const ctxAssets = w.getAssetsByKeys(w.umwAssets, assetIds);

    if (!ctxAssets || !ctxAssets.length) {
        console.error('No context found for: ' + JSON.stringify(assetIds));
        return;
    }

    if (ctxAssets.length > 1) {
        console.error('More than one context was defined for ' + assetId + ', ony one is supported.');
    }
    const ctx = ctxAssets[0];

    const loadImg = '<img class="Loading" alt="loading..." src="' + w.R + 'Startup/Pics/wait3.gif" />';
    const cookie = (w.cms && w.cms.cookie) || $.cookie;

    function getBillingCountryCode() {
        var $drp = $(ctx.cpf + 'drpCountry');
        if ($drp.length && $drp.is(':visible') && $drp.find(':selected').val()) {
            return $drp.find(':selected').val();
        }
        return ctx.countryCode;
    }

    function getDeliveryCountryCode() {
        var $drp = $(ctx.cpf + 'drpDeliveryCountry');
        if ($drp.length && $drp.is(':visible') && $drp.find(':selected').val()) {
            return $drp.find(':selected').val();
        }
        return ctx.deliveryCountryCode;
    }

    $(function() {
        //Turn off firefox autocomplete for checkboxes
        $(':checkbox').attr('autocomplete', 'off');
        const $cbxUseSameAddress = $(ctx.cpf + 'cbxUseSameAddress');

        if ($cbxUseSameAddress.length !== 0) {
            if (!w.isPostBack() && cookie('UseSameAddressForDelivery') != undefined) {
                if (cookie('UseSameAddressForDelivery') === 'true') {
                    $cbxUseSameAddress.check();
                } else if (cookie('UseSameAddressForDelivery') === 'false') {
                    $cbxUseSameAddress.uncheck();
                }
            }

            ToggleDeliveryAddress(!$cbxUseSameAddress.is(':checked'), true);

            $cbxUseSameAddress.click(function () {
                ToggleDeliveryAddress(!this.checked, false);
                cookie("UseSameAddressForDelivery", this.checked);
            });
        } else {
            cookie('UseSameAddressForDelivery') === 'false';
        }

        SetupPostCodeCheck();
        setupDeliveryAddresses();

        // If payment and delivery is visible -> initialize payment providers, get shipping costs
        var $paymentDelivery = $('div.PaymentDelivery');
        if ($paymentDelivery.is(':visible')) {
            setupPaymentDeliveryStep();
            GetDeliveryPrices();
        }

        var $confirm = $('div.Confirm');
        if ($confirm.is(':visible')) {
            setupConfirmStep();
        }

        $(ctx.cpf + "txbPostalCode").keyup(function() {
            validatePostalCode();
        });

        setTimeout(function() {
            validatePostalCode();
        }, 1000);

        function validatePostalCode() {
            var isNorway = getBillingCountryCode() === 'NO';

            var $tbxPostalCode = $(ctx.cpf + 'txbPostalCode');
            if ($tbxPostalCode.length) {
                if (isNorway) {
                    $.getPostalCodeInfo($tbxPostalCode.val().trim(), CheckOut2HandlePostalCode);
                } else {
                    $tbxPostalCode.removeClass('Invalid');
                }
            }
        }

        if (typeof ctx.payPalSupportedCountries != 'undefined') {
            var $drpCountry = $(ctx.cpf + 'drpCountry');
            if ($drpCountry.length) {
                $drpCountry.change(function() {
                    onCountryChanged(this.value);
                    validatePostalCode();
                });
                onCountryChanged($drpCountry.find(':selected').val());
            }
        }

        $('.js-detailed-cart-collapse-button').on('click',
            function() {
                var productDetails = $(this).parent().find('.js-detailed-cart-collapsible-content');
                if (productDetails.is(':visible')) {
                    productDetails.slideUp();
                } else {
                    productDetails.slideDown();
                }
            });

        if (ctx.showDeliveryDate) {
            var txbDeliveryDate = $(ctx.cpf + "txbDeliveryDate");
            var selectedDeliveryDate = txbDeliveryDate.val(); // min date bug in datepicker plugin workaround
            txbDeliveryDate.val('');
            txbDeliveryDate.datepicker({ minDate: ctx.minDeliveryDays + 'D' });
            txbDeliveryDate.datepicker("option", $.datepicker.regional["no"]);
            txbDeliveryDate.datepicker("option", "firstDay", 1);
            txbDeliveryDate.val(selectedDeliveryDate);
            $(ctx.cpf + "imgDeliveryDate").click(function () { txbDeliveryDate.focus(); });
        }

        //Visibility
        var rbl = $('#' + ctx.rblRegTypeId);
        var compDet = $('#CompanyDetails');
        var confCompNo = $('#CompanyDetails .CompanyNo');
        var confComp = $('#CompanyDetails .Company');
        var confCompEmail = $('#CompanyDetails .EMail');

        var deliveryComp = $('#' + ctx.pnlDeliveryCompanyId);
        var $useSameAddress = $('#' + ctx.cbxUseSameAddressId);

        // Private-mode layout merge: in Privat the contact-person section becomes part of the
        // company/billing section. Useful fields are moved out (FirstName, LastName up top;
        // Mobile + NewPassword down with the rest of the contact info), then the now-empty
        // contact-person container is hidden as a whole.
        var $newCustomerSubText = $('.Address .checkout-section-title .TitleContainer p');
        var $contactSectionTitle = $('.checkout-section-person > .TitleContainer');
        var $firstNamePanel = $('.checkout-section-person .FirstName');
        var $lastNamePanel = $('.checkout-section-person .LastName');
        var $mobilePanel = $('.checkout-section-person .Mobile');
        var $newPasswordPanel = $('.checkout-section-person .NewPassword');
        var $companyAddress1 = $('#CompanyDetails .Address1');
        var $companyEMailPanel = $('#CompanyDetails .EMail');
        var $privatLayoutMarker = $('.Address');
        var privatLayoutMoved = false;

        function rememberOrigPosition($panel) {
            $panel.data('umwOrigParent', $panel.parent()[0]);
            $panel.data('umwOrigPrev', $panel.prev()[0] || null);
        }
        function restoreOrigPosition($panel) {
            var origParent = $panel.data('umwOrigParent');
            var origPrev = $panel.data('umwOrigPrev');
            if (!origParent) return;
            if (origPrev) $(origPrev).after($panel);
            else $(origParent).prepend($panel);
        }

        function applyPrivatLayout() {
            if (privatLayoutMoved) return;
            if ($firstNamePanel.length && $companyAddress1.length) {
                rememberOrigPosition($firstNamePanel);
                $companyAddress1.before($firstNamePanel);
            }
            if ($lastNamePanel.length && $firstNamePanel.length) {
                rememberOrigPosition($lastNamePanel);
                $firstNamePanel.after($lastNamePanel);
            }
            // Mobile and NewPassword belong with the customer's contact info, so park
            // them right after the company-section EMail.
            if ($mobilePanel.length && $companyEMailPanel.length) {
                rememberOrigPosition($mobilePanel);
                $companyEMailPanel.after($mobilePanel);
            }
            if ($newPasswordPanel.length && $mobilePanel.length) {
                rememberOrigPosition($newPasswordPanel);
                $mobilePanel.after($newPasswordPanel);
            }
            $privatLayoutMarker.addClass('PrivatLayout');
            privatLayoutMoved = true;
        }

        function restoreCompanyLayout() {
            if (!privatLayoutMoved) return;
            restoreOrigPosition($firstNamePanel);
            restoreOrigPosition($lastNamePanel);
            restoreOrigPosition($mobilePanel);
            restoreOrigPosition($newPasswordPanel);
            $privatLayoutMarker.removeClass('PrivatLayout');
            privatLayoutMoved = false;
        }

        function findValidationElements(element) {
            if ($(element).children('.RequiredField').length > 0) {
                return [element];
            }
            var descendantDivs = [];
            var children = $(element).children();
            for (var i = 0; i < children.length; i++) {
                var tmp = findValidationElements(children[i]);
                descendantDivs = descendantDivs.concat(tmp);
            }
            return descendantDivs;
        };

        var invoiceAddressValidationElements = findValidationElements($('.InvoiceAddress')[0]);
        var deliveryAddressValidationElements = findValidationElements($('.DeliveryAddress')[0]);
        var paymentDeliveryValidationElements = findValidationElements($('.PaymentDelivery')[0]);

        var allValidationElements = invoiceAddressValidationElements.concat(deliveryAddressValidationElements).concat(paymentDeliveryValidationElements);

        // KHG-9869: in Privat mode the company-section EMail (txbEMail) is the customer's
        // primary email. The contact-section EMail is a duplicate that only makes sense for
        // a separate company contact person, so we hide it for Privat.
        var $contactSection = $('.checkout-section-person');
        var $contactEmailRow = $contactSection.find('.EMail');
        var $contactReferenceCodeRow = $contactSection.find('.ReferenceCode');

        // Email label swap: in Bedrift mode the company billing email label reads e.g.
        // "Firma e-post". In Privat that label is the customer's own email, so reuse the
        // contact-section email label text ("E-post") for the duration of Privat mode.
        var $lbtxbEMail = $("[id$='lbtxbEMail']").not("[id$='lbtxbContactEMail']").first();
        var $lbtxbContactEMail = $("[id$='lbtxbContactEMail']").first();
        var originalEMailLabelText = $lbtxbEMail.text();
        var contactEMailLabelText = $lbtxbContactEMail.length ? $lbtxbContactEMail.text() : originalEMailLabelText;

        function setCompanyDetailsVisible(instant) {
            if (rbl.find(':checked').val() == 'Private') {
                confCompNo.hide();
                confComp.hide();
                $contactEmailRow.hide();
                $contactReferenceCodeRow.hide();

                deliveryComp.hide();
                $('.ReqNo').hide();
                $('[id*="reqVatxbCompany"], [id*="reqVatxbDeliveryCompany"], [id*="reqVatxbReqNo"], [id*="reqVatxbContactEMail"], [id*="reqVatxbReferenceCode"]').each(function () {
                    w.ValidatorEnable(this, false);
                    $(this).closest('div').removeClass('ErrInp');
                });

                $newCustomerSubText.hide();
                $lbtxbEMail.text(contactEMailLabelText);
                applyPrivatLayout();
                // After moving the useful fields out, hide the now-empty contact-person container.
                $contactSection.hide();
            } else {
                if(compDet) {
                    compDet.css({"margin-top": "0", "padding-top": "0", "border-top": "0"});
                }
                confCompNo.show();
                confComp.show();
                $contactEmailRow.show();
                $contactReferenceCodeRow.show();
                deliveryComp.show();
                $('.ReqNo').show();

                $newCustomerSubText.show();
                $lbtxbEMail.text(originalEMailLabelText);
                restoreCompanyLayout();
                $contactSection.show();

                $('[id*="reqVatxbCompany"],[id*="reqVatxbReqNo"]').each(function () {
                    var validator = this;
                    // Enable validator only if the field is required (i.e. there is a validationElement for it)
                    $(invoiceAddressValidationElements).each(function () {
                        var validationElementPanel = this;
                        if ($.contains(validationElementPanel, validator) && $(validationElementPanel).is(':visible')) {
                            validator.enabled = true;
                            return false;
                        }
                        return true;
                    });
                });

                if (!$useSameAddress.length || !$useSameAddress.is(':checked')) {
                    $('[id*="reqVatxbDeliveryCompany"]').each(function () {
                        var validator = this;
                        $(deliveryAddressValidationElements).each(function () {
                            var validationElementPanel = this;
                            if ($.contains(validationElementPanel, validator) && $(validationElementPanel).is(':visible')) {
                                validator.enabled = true;
                                return false;
                            }
                            return true;
                        });
                    });
                }
            }
        };

        setCompanyDetailsVisible(true);

        $(allValidationElements).find('input').change(function (evt) {
            $(this).closest('div').toggleClass('ErrInp', !$(this).val());
        });

        rbl.click(function () { setCompanyDetailsVisible(false); });

        $('#' + ctx.btnNext1Id + ', #' + ctx.btnNext2Id).click(function () {
            var firstInvalid = null;

            for (var i = 0; i < allValidationElements.length; i++) {
                var element = allValidationElements[i];
                if ($('span.ErrMsg', element).is(":visible")) {
                    $(element).addClass('ErrInp');
                    if (!firstInvalid)
                        firstInvalid = element;
                } else {
                    $(element).removeClass('ErrInp');
                }
            }

            if (firstInvalid) {
                $('input, select', firstInvalid).select();
                var destination = $('input, select', firstInvalid).offset().top;
                $("html, body").animate({ scrollTop: destination }, "slow");
            }
        });

        if (ctx.referralsEnabled) {
            var $drpReferralName = $('#' + ctx.drpReferralName);
            var $drpReferralGroup = $('#' + ctx.drpReferralGroup);

            if ($drpReferralName && $drpReferralName.length > 0 && $drpReferralName.is(":visible")) {
                w.initReferrals($drpReferralGroup, $drpReferralName);
            }
        }

        var $rblPaymentOptions = $('#rblPaymentOptions');
        $rblPaymentOptions.find('input').click(function () {
            w.PubSub.publish('estore.callback.payment.changed', { paymentId: $(this).val() });
        });

        if (ctx.departmentsEnabled) {
            w.require(['departments/umw.department-selector.min'],
                function() {
                    var $departmentSelectorWidget = $('.js-department-selector').departmentselector({
                        labels: ctx.departmentsSelectorMessages,
                        departments: ctx.departmentsModel,
                        selectedDepartmentFiledId: ctx.hSelectedDepartmentId,
                    });

                    window.$departmentSelectorWidget = $departmentSelectorWidget;
                });
        }

        if (ctx.bonusEnabled) {
            w.require(['bonus/umw.bonus-to-spend.min'],
                function() {
                    var paymentId = '';
                    if ($rblPaymentOptions.length) {
                        paymentId = $rblPaymentOptions.find('input:checked').val();
                    }

                    var deliveryId = '';
                    var $rblDeliveryOptions = $('#rblDeliveryOptions');
                    if ($rblDeliveryOptions.length) {
                        deliveryId = $rblDeliveryOptions.find('input:checked').val();
                    }
                    var $bonusToSpendWidget = $('.js-bonus-to-spend-init').bonustospend({
                        labels: ctx.bonusToSpendMessages,
                        paymentAndDelivery: {
                            paymentId: $.mw_tryParseIntStrict(paymentId),
                            deliveryId: $.mw_tryParseIntStrict(deliveryId),
                            deliveryPostalCode: ctx.deliveryPostalCode,
                            deliveryCountryCode: ctx.deliveryCountryCode
                        },
                        includeVatInOrder: ctx.includeVatInOrder,
                        autoSpending: ctx.autoSpending,
                        bonusProductsPageUrl: ctx.bonusProductsPageUrl,
                        isCompanyUser: ctx.isCompanyUser
                    });

                    window.$bonusToSpendWidget = $bonusToSpendWidget;
                });
        }
    });

    function showWarning(message) {
        w.noty({
            text: message,
            killer: true,
            timeout: false,
            closeWith: ['button'],
            type: 'warning',
            modal: true,
            layout: 'center',
            buttons: [
                {
                    addClass: 'btn btn-primary',
                    text: 'Ok',
                    onClick: function($noty) {
                        $noty.close();
                    }
                }
            ]
        });
    }

    function showError(message) {
        w.noty({
            text: message,
            killer: true,
            timeout: false,
            closeWith: ['button'],
            type: 'error',
            modal: true,
            layout: 'center',
            buttons: [
                {
                    addClass: 'btn btn-primary',
                    text: 'Ok',
                    onClick: function($noty) {
                        $noty.close();
                    }
                }
            ]
        });
    }

    function onCountryChanged(countryCode) {
        var isStateRequired = _.contains(ctx.payPalSupportedCountries, countryCode);
        $(ctx.cpf + "pnlState").toggle(isStateRequired);
    };

    function onDeliveryCountryChanged(countryCode) {
        var isStateRequired = _.contains(ctx.payPalSupportedCountries, countryCode);
        $(ctx.cpf + "pnlDeliveryState").toggle(isStateRequired);
    };

    function CheckOut2HandlePostalCode(d) {
        var t = $(ctx.cpf + "txbPostalCode");
        var a = $(ctx.cpf + "txbPostalArea");

        t.removeClass("Invalid");

        if (d.valid === true) {
            a.val(d.result);
        } else {
            var postCodeVal = (t.val() || '').trim();
            if (postCodeVal && postCodeVal.length >= 4) {
                t.addClass("Invalid");
            }
        }
    }

    function CheckOut2HandleDeliveryPostalCode(d) {
        var t = $(ctx.cpf + "txbDeliveryPostalCode");
        var a = $(ctx.cpf + "txbDeliveryPostalArea");

        t.removeClass("Invalid");

        if (d.valid === true) {
            a.val(d.result);
        } else {
            var postCodeVal = (t.val() || '').trim();
            if (postCodeVal && postCodeVal.length >= 4) {
                t.addClass("Invalid");
            }
        }
    }

    function getSelectedPaymentId() {
        var val = $("div.PaymentOption input:checked").val();
        return parseInt(val);
    }

    function getPaymentProviderData(paymentId) {
        var $option = $('div.PaymentOption[data-optionid="' + paymentId + '"]');
        var providerName = $option.data('providername');
        if (providerName) {
            return {
                providerName: providerName,
                providerParams: $option.data('providerparams')
            };
        }
        return null;
    }

    function GetDeliveryPrices() {
        var delOpt = $("div.DeliveryOption.CalcPrice");
        if (delOpt.length > 0 && ctx.showDelPrices === true && $("div.PaymentDelivery").is(":visible")) {

            var useSameAddress = $(ctx.cpf + "cbxUseSameAddress").is(":checked");
            var txbPostCode = $(ctx.cpf + "txbPostalCode");
            var txbDelPostCode = $(ctx.cpf + "txbDeliveryPostalCode");
            var drpCountryCode = $(ctx.cpf + "drpCountry option:selected");
            var drpDelCountryCode = $(ctx.cpf + "drpDeliveryCountry option:selected");

            delOpt.each(function() {
                //Gather vars
                var t = $(this);
                var dt = t.find("input").val();
                var pc = useSameAddress === true || txbDelPostCode.length === 0
                    ? txbPostCode.val()
                    : txbDelPostCode.val();
                pc = (pc || '').trim();
                var cc = useSameAddress === true || drpDelCountryCode.length === 0
                    ? drpCountryCode.val()
                    : drpDelCountryCode.val();

                //Show load image
                if (t.find("img.Loading").length === 0) {
                    t.append(loadImg);
                }

                //Issue request
                $.publicFetch({
                    handler: "EStoreData",
                    data: {
                        a: "GetDeliveryPrice",
                        DeliveryID: dt,
                        PostCode: pc,
                        CountryCode: cc
                    },
                    success: function(d) {
                        t.find("img.Loading").remove();

                        if (d && d.length > 0) {
                            if (t.find("span.DeliveryPrice").length === 0) {
                                t.append('<span class="DeliveryPrice">' + d + '</span>');
                            } else {
                                t.find("span.DeliveryPrice").text(d);
                            }
                        }
                    },
                    error: function(xhr, type) {
                        if (type !== 'abort') {
                            t.find("span.DeliveryPrice").remove();
                            t.find("img.Loading").remove();
                        }
                    }
                });
            });
        }
    }

    function ToggleDeliveryAddress(visible, instant) {
        var $pnlDeliveryAddress = $('#pnlDeliveryAddressFields');

        if ($pnlDeliveryAddress.length > 0) {
            if (visible) {
                if (!ctx.loggedIn) CopyAddressToDeliveryAddress();
                instant ? $pnlDeliveryAddress.show() : $pnlDeliveryAddress.slideDown('fast');
            } else {
                instant ? $pnlDeliveryAddress.hide() : $pnlDeliveryAddress.slideUp('fast');
            }
        }

        $pnlDeliveryAddress.find('span.RequiredField').each(function () {
            var $requireField = $(this);
            var $validator = $requireField.siblings('span.ErrMsg');

            if ($validator.length) {
                if (visible) {
                    $validator[0].enabled = $requireField.is(':visible');

                    for (let i = 1; i < $validator.length; i++) {
                        $validator[i].enabled = true;
                    }

                } else {
                    for (let i = 0; i < $validator.length; i++) {
                        w.ValidatorEnable($validator[i], false);
                    }
                    $requireField.closest('div').removeClass('ErrInp');
                }
            }
        });

    }

    function CopyAddressToDeliveryAddress() {
        CopyValue("txbCompany", "txbDeliveryCompany");
        CopyValue("txbFirstName", "txbDeliveryFirstName");
        CopyValue("txbLastName", "txbDeliveryLastName");
        CopyValue("txbAddress1", "txbDeliveryAddress1");
        CopyValue("txbAddress2", "txbDeliveryAddress2");
        CopyValue("txbPostalCode", "txbDeliveryPostalCode");
        CopyValue("txbPostalArea", "txbDeliveryPostalArea");

        var txbMobile = $(ctx.cpf + "txbMobile");
        if (txbMobile && txbMobile.length > 0 && txbMobile.val().length > 0)
            CopyValue("txbMobile", "txbDeliveryPhone");
        else CopyValue("txbPhone", "txbDeliveryPhone");

        CopyValue("txbContactEMail", "txbDeliveryEMail");
    }

    function CopyValue(firstControlID, secondControlID) {
        var first = $(ctx.cpf + firstControlID),
            second = $(ctx.cpf + secondControlID);
        if (first && first.length > 0 && second && second.length > 0 && second.val() == "") {
            second.val(first.val());
        }
    }

    function setupDeliveryAddresses() {
        var $pnlAddress = $('.js-mainAddressPanel');
        if ($pnlAddress.length === 1 && !$pnlAddress.is(':visible')) {
            return;
        }

        var hasDeliveryAddressSaveDialogShown = false;
        var $btnNext1 = $(ctx.cpf + 'btnNext1');
        var $deliveryAddressTagifyInput = $(ctx.cpf + "deliveryAddressTagifyInput");
        var $hSaveDeliveryAddress = $(ctx.cpf + "hSaveDeliveryAddress");
        var $btnNewAddressLink = $(ctx.cpf + "btnNewAddressLink");

        var $txbDeliveryCompany = $(ctx.cpf + "txbDeliveryCompany");
        var $txbDeliveryFirstName = $(ctx.cpf + "txbDeliveryFirstName");
        var $txbDeliveryLastName = $(ctx.cpf + "txbDeliveryLastName");
        var $txbDeliveryAddress1 = $(ctx.cpf + "txbDeliveryAddress1");
        var $txbDeliveryAddress2 = $(ctx.cpf + "txbDeliveryAddress2");
        var $txbDeliveryPostalCode = $(ctx.cpf + "txbDeliveryPostalCode");
        var $txbDeliveryPostalArea = $(ctx.cpf + "txbDeliveryPostalArea");
        var $drpDeliveryCountry = $(ctx.cpf + "drpDeliveryCountry");
        var $txbDeliveryPhone = $(ctx.cpf + "txbDeliveryPhone");
        var $txbDeliveryEMail = $(ctx.cpf + "txbDeliveryEMail");
        var $hIsDefaultDeliveryAddress = $(ctx.cpf + "hIsDefaultDeliveryAddress");
        var $txbDeliveryDescription = $(ctx.cpf + "txbDeliveryDescription");
        var $hSelectedDeliveryAddressId = $(ctx.cpf + "hSelectedDeliveryAddressId");

        if (typeof ctx.payPalSupportedCountries != 'undefined') {
            if ($drpDeliveryCountry.length) {
                $drpDeliveryCountry.change(function() {
                    onDeliveryCountryChanged(this.value);
                    validateDeliveryPostalCode();
                });
                onDeliveryCountryChanged($drpDeliveryCountry.find(":selected").val());
            }
        }

        $txbDeliveryPostalCode.keyup(function() {
            validateDeliveryPostalCode();
        });

        let deliveryAddressTagifyInput;
        if ($deliveryAddressTagifyInput.length) {
            deliveryAddressTagifyInput = new w.Tagify($deliveryAddressTagifyInput[0],
                {
                    mode: 'select',
                    dropdown: {
                        maxItems: 100,
                        highlightFirst: true,
                        searchKeys: [
                            'CompanyName', 'FirstName', 'LastName', 'Address', 'Address2', 'PostCode', 'PostArea', 'Description'
                        ]
                    },
                    templates: {
                        dropdownItem: function (tagData) {
                            return `<div class='tagify__dropdown__item'>
                                    <span>${tagData.value}</span>
                                </div>`;
                        },
                    },
                });

            _updateDeliveryAddressesTagifyWhitelist(_getDefaultOrFirstDeliveryAddressId());

            deliveryAddressTagifyInput.on('change',
                function (evt) {
                    if (!evt || !evt.detail || !evt.detail.value) {
                        console.warn(
                            'Delivery addresses tagify selector: Did not find data in the event at evt.detail.value');
                        return;
                    }

                    const selectedAddresses = JSON.parse(evt.detail.value);
                    const selectedAddressId = selectedAddresses[0].id;

                    setDeliveryAddress(selectedAddressId);
                    if (selectedAddressId) {
                        $btnNewAddressLink.show();
                    } else {
                        $btnNewAddressLink.hide();
                    }
                });
        }

        var deliveryAddressId = parseInt(cookie('selectedDeliveryAddressId'));
        if (deliveryAddressId && ctx.deliveryAddressesModel && ctx.deliveryAddressesModel[deliveryAddressId]) {
            selectDeliveryAddress(deliveryAddressId);
        } else if (!w.isPostBack()) {
            //note: filter is used instead of find to support ie11
            var defaultAddresses = _.values(ctx.deliveryAddressesModel).filter(function(deliveryAddress) {
                return deliveryAddress.isDefault;
            });
            if (defaultAddresses && defaultAddresses.length) {
                selectDeliveryAddress(defaultAddresses[0].id);
            }
        }

        $btnNext1.click(function (e) {
            var deliveryFieldsAreValid = true;

            var $pnlDelivery = $('#pnlDeliveryAddressFields');
            $pnlDelivery.find('span.ErrMsg').each(function() {
                if ($(this).is(':visible')) {
                    deliveryFieldsAreValid = false;
                    return false;
                }
                return true;
            });

            if (!deliveryFieldsAreValid)
                return;

            if (!hasDeliveryAddressSaveDialogShown && $pnlDelivery.is(':visible')) {
                if (isNewAndNotEmptyDeliveryAddress()) {
                    e.preventDefault();
                    showDeliveryAddressSaveDialog(true);
                } else if (isExistingDeliveryAddressChanged()) {
                    e.preventDefault();
                    showDeliveryAddressSaveDialog(false);
                }
            }
            if ($hSelectedDeliveryAddressId.length)
                cookie('selectedDeliveryAddressId', $hSelectedDeliveryAddressId.val(), { expires: 1 });

            hasDeliveryAddressSaveDialogShown = false;
        });

        if ($btnNewAddressLink.length) {
            var newDeliveryAddressId = 0;

            if ($hSelectedDeliveryAddressId.length && parseInt($hSelectedDeliveryAddressId.val()) === newDeliveryAddressId) {
                $btnNewAddressLink.hide();
            }

            $btnNewAddressLink.click(function() {
                selectDeliveryAddress(newDeliveryAddressId);
                $btnNewAddressLink.hide();
            });
        }

        function validateDeliveryPostalCode() {
            var isNorway = getDeliveryCountryCode() === 'NO';

            if ($txbDeliveryPostalCode.length) {
                if (isNorway) {
                    $.getPostalCodeInfo($txbDeliveryPostalCode.val().trim(), CheckOut2HandleDeliveryPostalCode);
                } else {
                    $txbDeliveryPostalCode.removeClass('Invalid');
                }
            }
        }

        function _getDefaultOrFirstDeliveryAddressId() {
            const deliveryAddresses = _.values(ctx.deliveryAddressesModel);

            if (!deliveryAddresses || deliveryAddresses.length <= 0) {
                return null;
            }

            return (deliveryAddresses.find(a => a.isDefault) || deliveryAddresses[0]).id;
        }

        function _findPreSelectDeliveryAddressById(preselectDeliveryAddressId) {
            if (!ctx.deliveryAddressesDropdownSource || isNaN(preselectDeliveryAddressId)) {
                return null;
            }

            let preselectDeliveryAddress = null;

            ctx.deliveryAddressesDropdownSource.forEach(address => {
                if ((preselectDeliveryAddressId === 0 && address.id === 0)
                    || address.id === preselectDeliveryAddressId) {

                    preselectDeliveryAddress = address;
                }
            });

            return preselectDeliveryAddress;
        }

        function _updateDeliveryAddressesTagifyWhitelist(preselectDeliveryAddressId) {
            if (deliveryAddressTagifyInput) {
                if (ctx.deliveryAddressesDropdownSource && ctx.deliveryAddressesDropdownSource.length > 0) {
                    deliveryAddressTagifyInput.settings.whitelist = ctx.deliveryAddressesDropdownSource;

                    let preselectDeliveryAddress = _findPreSelectDeliveryAddressById(preselectDeliveryAddressId);
                    if (preselectDeliveryAddress) {
                        deliveryAddressTagifyInput.removeAllTags();
                        if(preselectDeliveryAddress.value === ''){
                            // Tagify requires a value, if value is empty string a "[object Object]" is shown instead, as tagigy trying to convert the object to string.
                            // Workaround by setting a space as value, till UX decides otherwise.
                            preselectDeliveryAddress.value = ' ';
                        };
                        deliveryAddressTagifyInput.addTags([preselectDeliveryAddress]);
                    }
                }
            }
        }

        function selectDeliveryAddress(deliveryAddressId) {
            _updateDeliveryAddressesTagifyWhitelist(deliveryAddressId);
            setDeliveryAddress(deliveryAddressId);
        }

        function setDeliveryAddress(deliveryAddressId) {
            if (deliveryAddressId === 0 || ctx.deliveryAddressesModel === null) {
                $txbDeliveryCompany.val('');
                $txbDeliveryFirstName.val('');
                $txbDeliveryLastName.val('');
                $txbDeliveryAddress1.val('');
                $txbDeliveryAddress2.val('');
                $txbDeliveryPostalCode.val('');
                $txbDeliveryPostalArea.val('');
                $txbDeliveryPhone.val('');
                $txbDeliveryEMail.val('');
                $txbDeliveryDescription.val('');
                $hIsDefaultDeliveryAddress.val('false');
            } else {
                var deliveryAddress = ctx.deliveryAddressesModel[deliveryAddressId];
                if (deliveryAddress) {
                    $txbDeliveryCompany.val(deliveryAddress.companyName);
                    $txbDeliveryFirstName.val(deliveryAddress.firstName);
                    $txbDeliveryLastName.val(deliveryAddress.lastName);
                    $txbDeliveryAddress1.val(deliveryAddress.address1);
                    $txbDeliveryAddress2.val(deliveryAddress.address2);
                    $txbDeliveryPostalCode.val(deliveryAddress.postalCode);
                    $txbDeliveryPostalArea.val(deliveryAddress.postalArea);
                    $drpDeliveryCountry.val(deliveryAddress.countryCode);
                    $txbDeliveryPhone.val(deliveryAddress.phone);
                    $txbDeliveryEMail.val(deliveryAddress.email);
                    $txbDeliveryDescription.val(deliveryAddress.description);
                    $hIsDefaultDeliveryAddress.val(deliveryAddress.isDefault);

                    validateDeliveryPostalCode();
                }
            }
            $hSelectedDeliveryAddressId.val(deliveryAddressId);
        }

        function showDeliveryAddressSaveDialog(isNewDeliveryAddress) {
            var dialog = "<div class='panel-body'>" +
                (isNewDeliveryAddress
                    ? ctx.messages.saveDelideryAddressQuestion
                    : ctx.messages.saveDelideryAddressChangesQuestion) +
                '</div>';
            var $dialog = $(dialog);
            $dialog.dialog({
                title: ctx.messages.save,
                resizable: false,
                modal: true,
                autoOpen: true,
                width: 400,
                buttons: {
                    no: {
                        text: top.TopFormText.no,
                        class: 'btn btn-link',
                        click: function() {
                            $(this).dialog('close');
                            $hSaveDeliveryAddress.val(false);
                            hasDeliveryAddressSaveDialogShown = true;
                            $btnNext1.click();
                        }
                    },
                    yes: {
                        text: top.TopFormText.yes,
                        autofocus: true,
                        class: 'btn btn-primary',
                        click: function() {
                            $(this).dialog('close');
                            $hSaveDeliveryAddress.val(true);
                            hasDeliveryAddressSaveDialogShown = true;
                            $btnNext1.click();
                        }
                    }
                }
            });
        }

        function isNewAndNotEmptyDeliveryAddress() {
            var deliveryAddressId = parseInt($hSelectedDeliveryAddressId.val());
            if (deliveryAddressId !== 0) {
                return false;
            }

            return $txbDeliveryCompany.length && $txbDeliveryCompany.val() !== '' ||
                $txbDeliveryFirstName.length && $txbDeliveryFirstName.val() !== '' ||
                $txbDeliveryLastName.length && $txbDeliveryLastName.val() !== '' ||
                $txbDeliveryAddress1.length && $txbDeliveryAddress1.val() !== '' ||
                $txbDeliveryAddress2.length && $txbDeliveryAddress2.val() !== '' ||
                $txbDeliveryPostalCode.length && $txbDeliveryPostalCode.val() !== '' ||
                $txbDeliveryPostalArea.length && $txbDeliveryPostalArea.val() !== '' ||
                $txbDeliveryPhone.length && $txbDeliveryPhone.val() !== '' ||
                $txbDeliveryEMail.length && $txbDeliveryEMail.val() !== '' ||
                $txbDeliveryDescription.length && $txbDeliveryDescription.val() !== '';
        }

        function isExistingDeliveryAddressChanged() {
            if ($hSelectedDeliveryAddressId.length) {
                var deliveryAddressId = parseInt($hSelectedDeliveryAddressId.val());

                if (deliveryAddressId > 0) {

                    var deliveryAddress = ctx.deliveryAddressesModel[deliveryAddressId];
                    if (deliveryAddress) {

                        return $txbDeliveryCompany.length &&
                            $txbDeliveryCompany.val() !== deliveryAddress.companyName ||
                            $txbDeliveryAddress1.length && $txbDeliveryAddress1.val() !== deliveryAddress.address1 ||
                            $txbDeliveryAddress2.length && $txbDeliveryAddress2.val() !== deliveryAddress.address2 ||
                            $txbDeliveryPostalCode.length && $txbDeliveryPostalCode.val() !== deliveryAddress.postalCode ||
                            $txbDeliveryPostalArea.length && $txbDeliveryPostalArea.val() !== deliveryAddress.postalArea ||
                            $drpDeliveryCountry.length && $drpDeliveryCountry.val() !== deliveryAddress.countryCode ||
                            $txbDeliveryDescription.length && $txbDeliveryDescription.val() !== deliveryAddress.description;

                            // Contact person dat should not be saved (UMWC-8166)
                            //$txbDeliveryFirstName.length && $txbDeliveryFirstName.val() !== deliveryAddress.firstName ||
                            //$txbDeliveryLastName.length && $txbDeliveryLastName.val() !== deliveryAddress.lastName ||
                            //$txbDeliveryPhone.length && $txbDeliveryPhone.val() !== deliveryAddress.phone ||
                            //$txbDeliveryEMail.length && $txbDeliveryEMail.val() !== deliveryAddress.email;
                    }
                }
            }
            return false;
        }
    }

    function SetupPostCodeCheck() {
        var $txbPostalCode = $(ctx.cpf + 'txbPostalCode');
        var $txbDeliveryPostalCode = $(ctx.cpf + 'txbDeliveryPostalCode');
        var $btnNext1 = $(ctx.cpf + 'btnNext1');
        var $btnNotNext1 = $(ctx.cpf + 'btnNotNext1');
        var $cbxUseSameAddress = $(ctx.cpf + 'cbxUseSameAddress');
        
        $btnNext1.hide();

        $btnNext1.click(function(e) {
            var valid = checkPostCode();
            if (valid === false) {
                e.preventDefault();
            }
        });

        $btnNotNext1.click(function(e) {
            checkPostCode();
            e.preventDefault();
        });

        $cbxUseSameAddress.click(function() { checkPostCode(); });

        function checkPostCode() {
            var usingBilling =
                ($cbxUseSameAddress.length > 0 && $cbxUseSameAddress.is(':checked')) ||
                ($cbxUseSameAddress.length == 0 && !$txbDeliveryPostalCode.is(':visible'));

            var $postCodeBox = usingBilling ? $txbPostalCode : $txbDeliveryPostalCode;

            var activeCountry = usingBilling ? getBillingCountryCode() : getDeliveryCountryCode();
            if (activeCountry !== 'NO') {
                $postCodeBox.parent().find('span.ValueCheckError, span.ValueCheckOK').remove();
                $btnNotNext1.hide();
                $btnNext1.show();
                return true;
            }

            if (!ctx.valueCheckSettings ||
                !ctx.valueCheckSettings.validValues ||
                ctx.valueCheckSettings.validValues.length == 0) {
                $btnNotNext1.hide();
                $btnNext1.show();
                return true;
            }

            var postCodeVal = ($postCodeBox.val() || '').trim();
            var valid = isValid(postCodeVal);
            var empty = postCodeVal === 0;

            if (valid) {
                $postCodeBox.parent().find('span.ValueCheckError').remove();
                $postCodeBox.parent().find('span.ValueCheckOK').remove();
                $postCodeBox.after('<span class="Success ValueCheckOK">' +
                    ctx.valueCheckSettings.validMessage +
                    '</span>');
                $btnNotNext1.hide();
                $btnNext1.show();
            } else {
                $postCodeBox.parent().find('span.ValueCheckError').remove();
                $postCodeBox.parent().find('span.ValueCheckOK').remove();

                if (!empty) {
                    $postCodeBox.after('<span class="ErrMsg ValueCheckError">' +
                        ctx.valueCheckSettings.invalidMessage +
                        '</span>');

                    if (ctx.valueCheckSettings.invalidMessageExplanation)
                        showWarning(ctx.valueCheckSettings.invalidMessageExplanation);
                }

                $btnNotNext1.show();
                $btnNext1.hide();
            }

            return valid;
        };

        function isValid(value) {
            if (!ctx.valueCheckSettings.validValues || ctx.valueCheckSettings.validValues.length == 0) {
                return true;
            }

            if (_.contains(ctx.valueCheckSettings.validValues, value)) {
                return true;
            }

            if ($.isNumeric(value)) {
                var validInRange = false;
                _.each(ctx.valueCheckSettings.validValues,
                    function(range) {
                        if (range.toString().indexOf('-') !== -1) {
                            var parts = range.split('-');
                            if ($.isNumeric(parts[0]) && $.isNumeric(parts[1])) {
                                var start = parseInt(parts[0]);
                                var end = parseInt(parts[1]);
                                var fValue = parseInt(value);
                                if (fValue >= start && fValue <= end) {
                                    validInRange = true;
                                }
                            }
                        }
                    });

                if (validInRange === true) {
                    return true;
                }
            }

            return false;
        };

        $txbPostalCode.add($txbDeliveryPostalCode).change(checkPostCode);

        checkPostCode();
    }

    function setupPaymentDeliveryStep() {
        'use strict';
        //var $paymentDelivery = $("div.PaymentDelivery");
        var $paymentOptionsCont = $('.js-payments-cont');
        var $paymentOptions = $('div.PaymentOption', $paymentOptionsCont);
        var $btnNext = $(ctx.cpf + 'btnNext2');

        var $hSpendBonusAmount = $(ctx.cpf + 'hSpendBonusAmount');
        var priceToPayByPaymentMethodIsZero = false;

        var $hPaymentAuthorization = $(ctx.cpf + 'hPaymentAuthorization');
        var authorizedPaymentMethodId = 0;

        if (w.paymentProviders) {
            var $extraInfosCont = $('.js-providers-extra-info', $paymentOptionsCont);
            $paymentOptions.each(function() {
                var $option = $(this);
                var optionId = $option.data('optionid');

                var providerName = $option.data('providername');
                if (providerName) {
                    var Provider = w.paymentProviders[providerName];
                    if (Provider) {
                        var params = {
                            paymentOption: $option,
                            $widgetCont: $extraInfosCont.find('[data-optionid="' + optionId + '"]'),
                            providerParams: $option.data('providerparams'),
                            onPaymentOptionReady: onPaymentOptionReady,
                            onPaymentOptionUnavailable: onPaymentOptionUnavailable,
                            onPaymentAuthorized: onPaymentAuthorized,
                            onPaymentAuthorizationFailed: onPaymentAuthorizationFailed
                        };
                        var provider = new Provider(params);
                        $option.data('provider', provider);
                        $option.find('label').addClass('loading');
                    }
                }

                $option.find('input').click(function() {
                    var $option = $(this).closest('.PaymentOption');
                    onPaymentOptionSelected($option);
                });

                function onPaymentOptionReady($option) {
                    $option.find('label').removeClass('loading');
                    var selectedOption = getSelectedPaymentId();
                    var optionId = $option.data('optionid');

                    if (selectedOption === optionId) {
                        $extraInfosCont.find('[data-optionid="' + optionId + '"]').show();
                    }
                }

                function onPaymentOptionUnavailable($option) {
                    $option.find('label').removeClass('loading');
                    $option.find('label').addClass('unavailable');
                    var optionId = $option.data('optionid');

                    var $rb = $option.find('input');
                    $rb.prop('checked', false);
                    $rb.prop('disabled', true);

                    $extraInfosCont.find('[data-optionid="' + optionId + '"]').hide();
                }

                function onPaymentOptionSelected($option) {
                    var optionId = $option.data('optionid');
                    $extraInfosCont.find('[data-optionid]').hide();
                    var provider = $option.data('provider');
                    if (provider && provider.isPaymentReady) {
                        $extraInfosCont.find('[data-optionid="' + optionId + '"]').show();
                    }
                }

                function onPaymentAuthorized($option, authorization) {
                    authorizedPaymentMethodId = $option.data('optionid');
                    $hPaymentAuthorization.val(JSON.stringify(authorization));
                    $btnNext.click();
                }

                function onPaymentAuthorizationFailed($option, isRejected) {
                    authorizedPaymentMethodId = 0;
                    unblockPayDel();
                    if (isRejected) {
                        showError(ctx.messages.paymentAuthorizeRejected);
                    } else {
                        showError(ctx.messages.paymentAuthorizeFailed);
                    }
                }
            });
        }

        w.PubSub.subscribe('estore.callback.bonus.datachanged',
            function(topic, contract) {
                if (contract) {
                    if (contract.totalCartSum === 0) {
                        priceToPayByPaymentMethodIsZero = true;
                        $paymentOptionsCont.hide();
                    } else {
                        priceToPayByPaymentMethodIsZero = false;
                        $paymentOptionsCont.show();
                    }
                }
            });

        $btnNext.click(function(evt) {
            if (!checkBonusToSpend() || !checkPaymentProvider() || !checkDepartment()) {
                evt.preventDefault();
                return;
            }

            function checkBonusToSpend() {
                var $bonusToSpendWidget = w.$bonusToSpendWidget; // created in markup (if enabled)
                if (!$bonusToSpendWidget) {
                    return true;
                }
                var spendBonusAmount = $bonusToSpendWidget.bonustospend('getSpendingAmount');
                if (spendBonusAmount === null) {
                    return false;
                }
                $hSpendBonusAmount.val(spendBonusAmount);
                return true;
            }

            function checkPaymentProvider() {
                if (priceToPayByPaymentMethodIsZero) {
                    return true;
                }
                var optionId = getSelectedPaymentId();
                var $option = $paymentOptions.filter('[data-optionid="' + optionId + '"]').first();
                var provider = $option.data('provider');
                if (provider && optionId !== authorizedPaymentMethodId) {
                    blockPayDel();
                    provider.authorize();
                    return false;
                }
                return true;
            }

            function checkDepartment() {
                var $departmentSelectorWidget = w.$departmentSelectorWidget; // created in markup (if enabled)
                if (!$departmentSelectorWidget) {
                    return true;
                }
                return $departmentSelectorWidget.departmentselector('validate');
            }
        });

        function blockPayDel() {
            $.blockUI();
        }

        function unblockPayDel() {
            $.unblockUI();
        }
    }

    function setupConfirmStep() {
        var $btnNext = $(ctx.cpf + 'btnNext3Bottom');
        var $next3Btns = $(ctx.cpf + 'btnNext3Top').add($btnNext);
        var $hPaymentAuthorization = $(ctx.cpf + 'hPaymentAuthorization');
        var paymentProvider = null, isPaymentAuthorized = false;

        $next3Btns.on('click',
            function(evt) {
                if (paymentProvider) {
                    if (!isPaymentAuthorized) {
                        blockConfirm();
                        evt.preventDefault();
                        paymentProvider.authorize();
                    }
                } else {
                    blockConfirm();
                }
            });

        if (w.paymentProviders) {
            var paymentMethodId = getSelectedPaymentId();
            var providerData = getPaymentProviderData(paymentMethodId);
            if (providerData) {
                var Provider = w.paymentProviders[providerData.providerName];
                if (Provider) {
                    var params = {
                        providerParams: providerData.providerParams,
                        onPaymentOptionUnavailable: onPaymentOptionUnavailable,
                        onPaymentAuthorized: onPaymentAuthorized,
                        onPaymentAuthorizationFailed: onPaymentAuthorizationFailed
                    };
                    paymentProvider = new Provider(params);
                }
            }
        }

        function onPaymentOptionUnavailable() {
            showError(ctx.messages.paymentInitializeFailed);
        }

        function onPaymentAuthorized($option, authorization) {
            //unblockPayDel(); // don't unblock to prevent changes and multi-clicks
            $hPaymentAuthorization.val(JSON.stringify(authorization));
            isPaymentAuthorized = true;
            $btnNext.click();
        }

        function onPaymentAuthorizationFailed($option, isRejected) {
            unblockConfirm();
            if (isRejected) {
                showError(ctx.messages.paymentAuthorizeRejected);
            } else {
                showError(ctx.messages.paymentAuthorizeFailed);
            }
        }


        function blockConfirm() {
            $.blockUI();
        }

        function unblockConfirm() {
            $.unblockUI();
        }
    }
})(window, jQuery, _);